import { makeStyles } from "@mui/styles";
import { height } from "@mui/system";

export default makeStyles((theme) => ({
  app: {
    margin: 0,
    padding: 0,
  },
  heroContainer: {
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px 90px',
    [theme.breakpoints.down('sm')]: {
      padding: '50px 20px 50px',
    },  
  },
  img: {
    width: '30%',
    aspectRatio: 1
  }
}));
